module.exports = __webpack_public_path__ + "img/login.2e632130.png";